import { inject, Injectable } from '@angular/core';
import {
  CallidusSkipperVersicherungspraemieCalcDto,
  ProductCallidusPipelineResultDto,
  PublicCallidusSkipperApiService,
  PublicCallidusSkipperContractCreateDto,
  VersicherungspraemieCalculationResultDto
} from '@backend/models';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SkipperStateService {
  private readonly publicCallidusSkipperApiService = inject(PublicCallidusSkipperApiService);

  /**
   * Skipper Prämienberechnung Ergebnis
   */
  private skipperCalculationResultSubject = new BehaviorSubject<VersicherungspraemieCalculationResultDto | null>(null);

  calculateSkipperPraemie(dto: CallidusSkipperVersicherungspraemieCalcDto): Observable<VersicherungspraemieCalculationResultDto> {
    return this.publicCallidusSkipperApiService
      .apiPublicCallidusSkipperContractVersicherungspraemiePost(dto)
      .pipe(
        tap((result) => this.skipperCalculationResultSubject.next(result))
      );
  }

  getSkipperCalculationResult(): VersicherungspraemieCalculationResultDto | null {
    return this.skipperCalculationResultSubject.value;
  }

  /**
   * Skipper Onboarding
   */
  submitSkipperOnboarding(dto: PublicCallidusSkipperContractCreateDto): Observable<ProductCallidusPipelineResultDto> {
    return this.publicCallidusSkipperApiService
      .apiPublicCallidusSkipperContractPost(dto);
  }
}
